/* eslint-disable react/prop-types */
import React from 'react';
import { useFormikContext } from 'formik';

import DatePicker from '@components/form/DatePicker';
import SociollaErrorMessage from './SociollaErrorMessage';

function SociollaDatePicker({ name, onChange, ...otherProps }) {
  const { setFieldValue, errors, touched, values } = useFormikContext();

  return (
    <>
      <DatePicker
        onChange={async (value) => {
          await setFieldValue(name, new Date(value).toDateString());
          if (onChange) {
            onChange(new Date(value).toDateString());
          }
        }}
        value={values[name]}
        name={name}
        {...otherProps}
      />
      <SociollaErrorMessage error={errors[name]} visible={touched[name]} />
    </>
  );
}

export default SociollaDatePicker;
